import { Button, FormLabel, Grid, MenuItem, OutlinedInput, Select, Stack } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { apiEndPoint } from "services";
import { postRequest } from "services/api";

const columns = [
  { field: "Item", headerClassName: "headingbg-color", headerName: "Item", width: 80 },
  { field: "Pack", headerClassName: "headingbg-color", headerName: "Pack", width: 80 },
  {
    field: "Description",
    headerClassName: "headingbg-color",
    headerName: "Description",
  },
  {
    field: "Lot",
    headerClassName: "headingbg-color",
    headerName: "Lot",
  },
  {
    field: "Location",
    headerClassName: "headingbg-color",
    headerName: "Location",
  },
  {
    field: "LPN",
    headerClassName: "headingbg-color",
    headerName: "LPN",
  },
  {
    field: "OnHandCases",
    headerClassName: "headingbg-color",
    headerName: "On Hand QTY",
  },
  {
    field: "OnHandQuantity",
    headerClassName: "headingbg-color",
    headerName: "On Hand EA",
  },

  // { field: 'Lot', headerClassName: "headingbg-color", headerName: 'Lot' },
  // { field: 'Location', headerClassName: "headingbg-color", headerName: 'Location' },

  // { field: 'LPN', headerClassName: "headingbg-color", headerName: 'LPN' },

  {
    field: "InTransitQty",
    headerClassName: "headingbg-color",
    headerName: "In Transit Qty",
  },
  {
    field: "InTransitPcs",
    headerClassName: "headingbg-color",
    headerName: "In Transit EA",
  },
  {
    field: "AvailableQty",
    headerClassName: "headingbg-color",
    headerName: "Available Qty",
  },
  {
    field: "AvailablePcs",
    headerClassName: "headingbg-color",
    headerName: "Available Pcs",
  },
  {
    field: "AllocatedQty",
    headerClassName: "headingbg-color",
    headerName: "Allocated Qty",
  },
  {
    field: "AllocatedPcs",
    headerClassName: "headingbg-color",
    headerName: "Allocated Pcs",
  },
  {
    field: "PickedQty",
    headerClassName: "headingbg-color",
    headerName: "Picked Qty",
  },
  {
    field: "PickedPcs",
    headerClassName: "headingbg-color",
    headerName: "Picked Pcs",
  },
  {
    field: "CUBE",
    headerClassName: "headingbg-color",
    headerName: "Item Cuft",
  },
  {
    field: "TotalCUBE",
    headerClassName: "headingbg-color",
    headerName: "Total Cuft",
  },

  // { field: 'Status', headerClassName: "headingbg-color", headerName: 'Status' },
  {
    field: "GrossWeight",
    headerClassName: "headingbg-color",
    headerName: "Gross Weight",
  },
  {
    field: "LOTTABLE01",
    headerClassName: "headingbg-color",
    headerName: "Lottable 01",
  },
  {
    field: "LOTTABLE02",
    headerClassName: "headingbg-color",
    headerName: "Lottable 02",
  },
  // { field: 'NetWeight', headerClassName: "headingbg-color", headerName: 'Net Weight' },
  // { field: 'TareWeight', headerClassName: "headingbg-color", headerName: 'Tare Weight' },
  // { field: 'dataAsOfDT', headerClassName: "headingbg-color", headerName: 'Date', width: 150 },
];

const InventoryLpnTable = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = React.useState([]);
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [clearFormData, setClearFormData] = useState(false);

  const fetchTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    let payload = {
      custCode: userSetting?.[0]?.currCustomer,
      whseCode: userSetting?.[0]?.currWarehouse,
      item: 'all',
     
    };
    const response = await postRequest(
      "user/getRprt_inventoryBalLPNwise_forExcelExport",
      payload,
      headers
    );
    setClearFormData(false);
    setData(response.data.Payload.Table);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTableData();
  }, [startDate, endDate, userSetting]);

  const rows = data && data.map((c, index) => ({
    id: index,
    Item: c.Item,
    Pack: c.Pack,
    Description: c.Description,
    OnHandCases: c.OnHandCases,
    Lot: c.Lot,
    Location: c.Location,
    LPN: c.LPN,
    OnHandQuantity: c.OnHandQuantity,
    InTransitQty: c.InTransitQty,
    AvailableQty: c.AvailableQty,
    AllocatedQty: c.AllocatedQty,
    PickedQty: c.PickedQty,
    Status: c.Status,
    GrossWeight: c.GrossWeight,
    NetWeight: c.NetWeight,
    TareWeight: c.TareWeight,
    dataAsOfDT: c.dataAsOfDT,
    InTransitPcs: c.InTransitPcs,
    AvailablePcs: c.AvailablePcs,
    AllocatedPcs: c.AllocatedPcs,
    PickedPcs: c.PickedPcs,
    CUBE: c.CUBE,
    TotalCUBE: c.TotalCUBE,
    LOTTABLE01: c.LOTTABLE01,
    LOTTABLE02: c.LOTTABLE02
    
  }));


  useEffect(() => {
    if(clearFormData) {
      fetchTableData()
    }
  }, [clearFormData])

  return (
    <>
      <div
        style={{
          height: 490,
          width: "100%",
          marginTop: "20px",
          background: "#fff",
        }}
      >
        <DataGridPremium
          loading={isLoading}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
          columns={columns}
          rows={rows}
          sx={{ flex: 1, "& .MuiButton-text": { fontSize:  "14px"} }}
          pagination
          pageSizeOptions={[30,50, 100, 200]}
          initialState={{pagination: { paginationModel: { pageSize: 50 } }}}
        ></DataGridPremium>
      </div>
    </>
  );
};

export default InventoryLpnTable;
